import { render, staticRenderFns } from "./ResumenPmi.vue?vue&type=template&id=9ff11a7e&"
import script from "./ResumenPmi.vue?vue&type=script&lang=js&"
export * from "./ResumenPmi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports